import React from "react";

import { queries as ktxQueries } from "lib/build/dashboards/ktx/queries";
import { Origin } from "lib/build/events";
import {
	LiveDonorScreeningInProgress,
	liveDonorScreeningInProgressMessages
} from "lib/build/forms/ktx/basic-registration-data/liveDonorScreening";

import { useFormatMessageMap } from "src/common/hooks/useFormatMessageMap";
import { useLastEventByQuery } from "src/features/events";

export function useLiveDonorScreening(): {
	value: string;
	timestamp?: string;
	origin?: Origin;
} {
	const event = useLastEventByQuery<{
		liveDonorScreeningInProgress: LiveDonorScreeningInProgress;
	}>(ktxQueries.liveDonorScreening);
	const formatMessage = useFormatMessageMap();

	return React.useMemo(
		() =>
			event === undefined
				? { value: "-" }
				: {
						value: formatMessage(
							liveDonorScreeningInProgressMessages,
							event.value.liveDonorScreeningInProgress
						),
						timestamp: event.timestamp,
						origin: event.origin
					},
		[event, formatMessage]
	);
}
